<template>
  <b-navbar>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{path: '/'}">
        {{title}}
      </b-navbar-item>
    </template>

    <template slot="start">
      <b-navbar-item v-for="menuItem in menuItems"
                     :key="menuItem.id"
                     tag="router-link"
                     :to="{path: menuItem.path}"
      >
        {{menuItem.name}}
      </b-navbar-item>
    </template>

    <template slot="end">
      <b-navbar-item>
        <router-link :to="{path: '/about'}">
          <app-clock></app-clock>
        </router-link>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
  import {mapGetters} from 'vuex';
  import BNavbarItem from "buefy/src/components/navbar/NavbarItem";
  import BNavbar from "buefy/src/components/navbar/Navbar";
  import Clock from './main/Clock';

  export default {
    components: {
      BNavbar,
      BNavbarItem,
      appClock: Clock
    },
    name: "top-bar",
    data() {
      return {
        staticTitle: 'The Butler'
      };
    },
    computed: {
      ...mapGetters('ui', ['isMenuVisible']),
      ...mapGetters('mqtt', ['mqttConnected']),
      ...mapGetters('auth', ['permissions']),
      ...mapGetters('objects', ['boards']),
      burgerClassName() {
        const base = 'navbar-burger burger';

        return this.isMenuVisible ? `${base} is-active` : base;
      },
      burgerAriaExpanded() {
        return this.isMenuVisible ? 'true' : 'false';
      },
      title() {
        return this.mqttConnected ? this.staticTitle : `${this.staticTitle} (offline)`;
      },
      menuItems() {
        const arr = this.permissions.filter(item => parseInt(item['menu_item']) === 1);
        this.boards.forEach(item => {
          if (parseInt(item.id) !== 1) {
            arr.unshift({
              id: (10000 + item.id),
              menu_item: 1,
              name: item.name,
              path: '/boards/' + item.id
            });
          }
        });
        arr.push({
          id: 0,
          menu_item: 1,
          name: 'Logout',
          path: '/logout'
        });

        return arr;
      }
    },
    methods: {
      closeMenu() {
        // TODO: close menu...
      },
      handleClickOnBurger() {
        this.$store.commit('ui/TOGGLE_MENU');
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/_all";

  .top-bar {
    min-height: 3.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
  }

  .top-bar.is-light {
    background-color: $black;
    color: $white;
  }

  .navbar-brand h6 {
    font-size: 1.5rem;
  }

  @media screen and (min-width: 32px) {
    .navbar-burger {
      display: block;
    }
  }
</style>